import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/consumer/Link';

const PDPDiscontinuedMessage = ({ discontinuedCategoryMsg }) => {
  if (!discontinuedCategoryMsg?.category) {
    return 'Sorry, this product has been discontinued.';
  }
  return (
    <>
      Sorry, this product has been discontinued. Discover other stylish{' '}
      <Link to={discontinuedCategoryMsg.link}>
        {discontinuedCategoryMsg.category}
      </Link>
    </>
  );
};

PDPDiscontinuedMessage.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string,
  }),
};

export default PDPDiscontinuedMessage;
